import { verticalRequest } from './http';

// Paged, each unit with its `rooms[]`. Query: `condo_id`, `search` (unit name).
export const listUnits = params => verticalRequest({ path: '/units', params });

// `{condo_id, name, kind, active, rooms: [names]}`. Rooms are for a rental
// unit only (422 `rooms_not_allowed`).
export const createUnit = fields =>
  verticalRequest({ method: 'post', path: '/units', data: fields });

// Partial `{name, kind, active}`. 409 `kind_locked` while residents exist.
export const updateUnit = (id, fields) =>
  verticalRequest({ method: 'put', path: `/units/${id}`, data: fields });

// 409 `in_use` (with `residents` and `tickets` booleans).
export const deleteUnit = id =>
  verticalRequest({ method: 'delete', path: `/units/${id}` });

// `{name}`; the name defaults to `Room N` when left out.
export const createRoom = (unitId, fields) =>
  verticalRequest({
    method: 'post',
    path: `/units/${unitId}/rooms`,
    data: fields,
  });

export const updateRoom = (unitId, roomId, fields) =>
  verticalRequest({
    method: 'put',
    path: `/units/${unitId}/rooms/${roomId}`,
    data: fields,
  });

export const deleteRoom = (unitId, roomId) =>
  verticalRequest({
    method: 'delete',
    path: `/units/${unitId}/rooms/${roomId}`,
  });
